import React from 'react';

function Footer() {
  return (
    <footer className="bg-primary text-white p-4 mt-auto">
      <div className="container mx-auto text-center">
        &copy; {new Date().getFullYear()} Mark Beattie. All rights reserved. | Privacy Policy | Contact:{" "}
        <a href="mailto:info@markbeattie.ca" className="underline decoration-white/50 underline-offset-2 hover:text-white hover:decoration-white">
          info@markbeattie.ca
        </a>
      </div>
    </footer>
  );
}

export default Footer;